import { render, staticRenderFns } from "./additional_accesories.vue?vue&type=template&id=746df971&"
import script from "./additional_accesories.vue?vue&type=script&lang=js&"
export * from "./additional_accesories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports